import React from 'react';
import Header from '@sharedComponent/header/header';
import LottieComponent from '@sharedComponent/lottie-component';
import LottieFile from '@assets/lottiefiles';
import { Col, Row, Table, Button } from 'antd';
import GifLoader from '@sharedComponent/gif-loader';

// const { RangePicker } = DatePicker;
// const dateFormat = 'MM/DD/YYYY';
const CreateCommissionReportPresentational = ({ formRef, handleSummaryForm, userDetails, onFinishModal, state, summaryForm }) => {
	const columns = [
		{
			title: 'Company',
			dataIndex: 'company',
			key: 'company',
			sorter: (a, b) => a.company.localeCompare(b.company),
		},
		{
			title: 'Customer',
			dataIndex: 'customer',
			sorter: (a, b) => a.customer.localeCompare(b.customer),
			key: 'customer',
		},
		{
			title: 'Order',
			dataIndex: 'order',
			key: 'order',
			sorter: (a, b) => a.order.localeCompare(b.order),
		},
		{
			title: 'Product',
			dataIndex: 'product',
			sorter: (a, b) => a.product.localeCompare(b.product),
			key: 'product',
		},
		{
			title: 'Product Price',
			dataIndex: 'totalPrice',
			sorter: (a, b) => a.totalPrice.localeCompare(b.totalPrice),
			key: 'totalPrice',
		},
		{
			title: 'Commission %',
			dataIndex: 'commission',
			sorter: (a, b) => a.commission.localeCompare(b.commission),
			key: 'commission',
		},
		{
			title: 'commission Amount',
			dataIndex: 'commissionAmount',
			sorter: (a, b) => a.commissionAmount - b.commissionAmount,
			key: 'commissionAmount',
			render: (value) => <Col> $ {value}</Col>,
		},
		// {
		// 	title: '',
		// 	dataIndex: 'title',
		// 	key: 'title',
		// 	render: () => {
		// 		return (
		// 			<Row>
		// 				<Col className="action_square_edit" xl={4} lg={4} md={4} sm={4} xs={4}>
		// 					<EditOutlined />{' '}
		// 				</Col>
		// 				<Col className="action_square_transfer" xl={4} lg={4} md={4} sm={4} xs={4}>
		// 					<SwapOutlined />
		// 				</Col>
		// 				<Col className="action_square_delete" xl={4} lg={4} md={4} sm={4} xs={4}>
		// 					<DeleteOutlined />{' '}
		// 				</Col>
		// 			</Row>
		// 		);
		// 	},
		// },
	];

	const dataSource = [
		{
			company: '1',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 700,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '1',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 700,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '1',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 700,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '1',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 700,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '1',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 700,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '2',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 600,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '2',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 700,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '2',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 600,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '2',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 700,
			commission: '10%',
			totalPrice: '$12345',
		},
		{
			company: '2',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commission: '10%',
			totalPrice: '$12345',
			commissionAmount: 600,
		},
		{
			company: '3',
			customer: 'Joe ',
			order: 'Abc 124',
			product: 'Monthly sub',
			commissionAmount: 900,
			commission: '10%',
			totalPrice: '$12345',
		},
	];

	const footer = (value) => {
		let total = 0;
		value.map((e) => {
			total = total + e.commissionAmount;
		});
		return (
			<Row className="tb_foolter_area">
				<Col xl={1}></Col>
				<Col xl={20} className="total">
					Total
				</Col>
				<Col xl={3} className="total_amt">
					{' '}
					$ {total}
				</Col>
			</Row>
		);
	};

	return (
		<>
			{state.loading ? (
				<Col style={{ display: 'flex', height: '100vh', justifyContent: 'center', alignItems: 'center' }}>
					{/* <LottieComponent width="10%" height="10%" file={LottieFile.Loading} /> */}
					<GifLoader />
				</Col>
			) : (
				<>
					<Header title="Dashboard / Commission Summary/ Bri Manager" />
					<Col className="create-commission-report-container">
						<Row>
							<Col xl={12} lg={12} md={12} sm={24} xs={24} className="create-commission-report-card-header">
								Bri Manager Commission Summery : 08/02/2020
							</Col>
							<Col xl={12} lg={12} md={12} sm={24} xs={24} className="create-commission-report-card-header-right"></Col>
						</Row>
						<Col style={{ marginTop: 25, padding: 10, border: '1.2px solid #DDE2EA' }}>
							<Table
								pagination={{
									position: ['bottomCenter', 'bottomCenter'],
									defaultPageSize: 5,
									showSizeChanger: true,
									pageSizeOptions: ['5', '10'],
								}}
								dataSource={dataSource}
								columns={columns}
								footer={footer}
							/>
						</Col>

						<Row style={{ marginTop: 20 }}>
							<Col className="notes">NOTES:</Col>
							<Col className="cards_content" style={{ marginTop: 20 }}>
								<Col>Hi Bri,</Col>
								<Col>
									Please see your July 2020 Commission report review and approval is due by 08/15/2020 failure to provoide
									modificationsprior to Midnight 08/02./2020 will be an implied approval
								</Col>
								Thank you
							</Col>
						</Row>
						<Row className="send-commission-report">
							<Button
								type="primary"
								style={{ borderRadius: 5 }}
								size={'middle'}
								className="send-commission-report"
							>
									
								Send Commission Report
							</Button>
						</Row>
					</Col>
				</>
			)}
		</>
	);
};

export default CreateCommissionReportPresentational;
